/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnChanges, OnInit, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {SpecialOrderMaterialDeliveryDetailModel} from '../../../api/ms-specialorders/contracts/special-order-material-delivery-detail.model';

@Component({
    selector: 'app-material-list-detail',
    templateUrl: './material-list-detail.component.html',
    styleUrls: ['./material-list-detail.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaterialListDetailComponent implements OnInit, OnChanges {

    /** The material deliveries array**/
    @Input() materialDeliveries: SpecialOrderMaterialDeliveryDetailModel[];
    /** The material transport mode document type **/
    @Input() transportDocument: string;
    /** The material sales unit **/
    @Input() materialUnits: string;

    constructor() {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['materialDeliveries'].firstChange) {
            this.materialDeliveries = changes['materialDeliveries'].currentValue;
        }
    }

}
